"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsDormantSessionsFetched = exports.selectIsActiveSessionsFetched = exports.selectFixedSessionsStatusFulfilled = exports.selectFixedSessionsPoints = exports.selectFixedSessionsList = exports.selectDormantFixedSessionsState = exports.selectActiveFixedSessionsState = void 0;
const reselect_1 = require("reselect");
const sessionFiltersSlice_1 = require("./sessionFiltersSlice");
const selectActiveFixedSessionsState = (state) => state.fixedSessions.activeSessions;
exports.selectActiveFixedSessionsState = selectActiveFixedSessionsState;
const selectDormantFixedSessionsState = (state) => state.fixedSessions.dormantSessions;
exports.selectDormantFixedSessionsState = selectDormantFixedSessionsState;
const selectFixedSessionsStatusFulfilled = (state) => state.fixedSessions.status === "FULFILLED" /* StatusEnum.Fulfilled */;
exports.selectFixedSessionsStatusFulfilled = selectFixedSessionsStatusFulfilled;
const selectFixedSessionsState = (state) => state.fixedSessions;
const selectIsActiveSessionsFetched = (0, reselect_1.createSelector)([selectFixedSessionsState], (fixedSessionsState) => fixedSessionsState.isActiveSessionsFetched);
exports.selectIsActiveSessionsFetched = selectIsActiveSessionsFetched;
const selectIsDormantSessionsFetched = (0, reselect_1.createSelector)([selectFixedSessionsState], (fixedSessionsState) => fixedSessionsState.isDormantSessionsFetched);
exports.selectIsDormantSessionsFetched = selectIsDormantSessionsFetched;
const transformSessionData = (sessions) => sessions.map(({ id, title, lastMeasurementValue, startTimeLocal, endTimeLocal, latitude, longitude, streams, lastHourlyAverageValue, }) => {
    var _a, _b, _c;
    const firstStream = streams[Object.keys(streams)[0]] || {};
    let averageValue = null;
    if (firstStream &&
        ("average_value" in firstStream || "averageValue" in firstStream)) {
        averageValue =
            (_b = (_a = firstStream.average_value) !== null && _a !== void 0 ? _a : firstStream.averageValue) !== null && _b !== void 0 ? _b : null;
    }
    else {
        averageValue = (_c = lastHourlyAverageValue !== null && lastHourlyAverageValue !== void 0 ? lastHourlyAverageValue : lastMeasurementValue) !== null && _c !== void 0 ? _c : null;
    }
    return {
        id,
        title,
        sensorName: (firstStream === null || firstStream === void 0 ? void 0 : firstStream.sensorName) || "",
        lastMeasurementValue,
        startTime: startTimeLocal,
        endTime: endTimeLocal,
        averageValue,
        point: {
            lat: latitude,
            lng: longitude,
            streamId: firstStream.id.toString() || "0",
        },
        streamId: firstStream.id || 0,
    };
});
const selectSessionsByType = (0, reselect_1.createSelector)([
    selectActiveFixedSessionsState,
    selectDormantFixedSessionsState,
    (_, type) => type,
], (activeSessions, dormantSessions, type) => {
    return type === sessionFiltersSlice_1.FixedSessionsTypes.ACTIVE
        ? activeSessions
        : dormantSessions;
});
const selectTransformedSessionsByType = (0, reselect_1.createSelector)([selectSessionsByType], (sessions) => transformSessionData(sessions));
const selectFixedSessionsPoints = (0, reselect_1.createSelector)([selectTransformedSessionsByType], (transformedSessions) => {
    return transformedSessions.map(({ id, title, sensorName, lastMeasurementValue, averageValue, startTime, endTime, point, }) => ({
        id,
        title,
        sensorName,
        startTime,
        endTime,
        lastMeasurementValue,
        averageValue,
        point,
    }));
});
exports.selectFixedSessionsPoints = selectFixedSessionsPoints;
const selectFixedSessionsList = (0, reselect_1.createSelector)([selectTransformedSessionsByType], (transformedSessions) => {
    return transformedSessions.map(({ id, title, sensorName, averageValue, startTime, endTime, streamId, }) => ({
        id,
        title,
        sensorName,
        averageValue,
        startTime,
        endTime,
        streamId,
    }));
});
exports.selectFixedSessionsList = selectFixedSessionsList;
